export const CACHE_STALE_TIME = 5 * 60 * 1000 // 5 minutes
export const CACHE_GC_TIME = 24 * 60 * 60 * 1000 // 24 hours
export const QUERY_CACHE_KEY = 'kanguro_rq_cache'
export const SESSION_QUERY_KEY = ['session'] as const
export const USER_QUERY_KEY = ['user'] as const
export const QUERY_DEFAULT_RETRY = 1
export const QUERY_NETWORK_MODE = 'online' as const
export const SESSION_NETWORK_MODE = 'offlineFirst' as const
export const KEYCLOAK_STALE_TIME = 5 * 60_000 // 5 minutes
export const KEYCLOAK_GC_TIME = 10 * 60_000 // 10 minutes

export const ONBOARDING_TRACE_QUERY_KEY = 'onboarding-trace'

export const PAYMENT_QUERY_KEYS = {
  policies: ['payment', 'policies'] as const,
  pets: ['payment', 'pets'] as const,
  petVets: (name: string) => ['pet-vets', name] as const,
  banks: ['payment', 'banks'] as const,
  userAccount: ['payment', 'user-account'] as const,
  keycloak: (product: string) => ['payment', 'keycloak', product] as const,
  all: ['payment'] as const,
}

export const TELEVET_QUERY_KEYS = {
  embeddedLink: ['televet', 'embedded-link'] as const,
}

export const RENTERS_QUERY_KEYS = {
  policies: ['renters', 'policies'] as const,
  petBreeds: ['renters', 'pet-breeds'] as const,
  additionalParties: (policyId: string) =>
    ['renters', 'additional-parties', policyId] as const,
  petAdditionalParty: (policyId: string) =>
    ['renters', 'pet-additional-party', policyId] as const,
  all: ['renters'] as const,
}

export const CLAIMS_QUERY_KEYS = {
  all: ['claims'] as const,
  renters: ['claims', 'renters'] as const,
  petLists: ['claims', 'pet', 'list'] as const,
  petList: (kind: string, page: number) =>
    ['claims', 'pet', 'list', kind, page] as const,
  petDocuments: (claimId: string) =>
    ['claims', 'pet', 'documents', claimId] as const,
  petDetail: (claimId: string) => ['claims', 'pet', 'detail', claimId] as const,
}
